import { handleActions, Action } from "redux-actions";
import { SET_ERROR, RESET_ERROR } from "actions/constants/error";
import { IAppState } from "state";
import { IError } from "models/IError";

export const error = handleActions<IError | null, any>(
    {
        [SET_ERROR]: (_, { payload }: Action<IError>) => {
            return payload;
        },

        [RESET_ERROR]: () => null,
    },

    null
);

export const getError = (state: IAppState) => state.error;
